import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface IMotivoRequest {
  que: number;
  tope: string;
  cmd: string;
  codigo: string;
  tipo: string;
  descripcion: string;
  tipo_motivo: string;
  iIdioma: number;
}

export interface IMotivo {
  motivo: string;
  tipo: string;
  descripcion: string;
  tipo_motivo: string;
}

export interface IMotivoResponse {
  data: IMotivo[];
  success: boolean;
}

export interface IOpcionesRequest {
  sTabla: string;
  sCampo: string;
  iIdioma: number;
}

export interface IOpcionesResponse {
  data: IOpcion[];
  success: boolean;
}

export interface IOpcion {
  sOpcion: string;
  sValor: string;
}

export interface IAddMotivoResponse {
  success: boolean;
  data: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MotivoService {

  constructor(private http: HttpClient) {}

  GetMotivos(): Observable<IMotivoResponse> {
    const request: IMotivoRequest = {
      que: 4,
      tope: "999",
      cmd: "",
      codigo: "0",
      tipo: "",
      descripcion: "",
      tipo_motivo: "",
      iIdioma: 0
    };
    return this.http.post<IMotivoResponse>(environment.apiNewBackBaseUrl + "Motivos/MotivosList", request);
  }

  SetMotivo(data: IMotivoRequest): Observable<boolean> {
    return this.http.post<boolean>(environment.apiNewBackBaseUrl + "Motivos/SetMotivo", data);
  }

  AddMotivo(motivo: IMotivo): Observable<IAddMotivoResponse> {
    const request: IMotivoRequest = {
      que: 1,
      tope: "100",
      cmd: "",
      codigo: motivo.motivo,
      tipo: motivo.tipo,
      descripcion: motivo.descripcion,
      tipo_motivo: motivo.tipo_motivo,
      iIdioma: 0
    };
    return this.http.post<IAddMotivoResponse>(environment.apiNewBackBaseUrl + "Motivos/MotivosAdd", request);
  }

  UpdateMotivo(motivo: IMotivo): Observable<IAddMotivoResponse> {
    const request: IMotivoRequest = {
      que: 2,
      tope: "",
      cmd: "",
      codigo: motivo.motivo,
      tipo: motivo.tipo,
      descripcion: motivo.descripcion,
      tipo_motivo: motivo.tipo_motivo,
      iIdioma: 0
    };
    return this.http.post<IAddMotivoResponse>(environment.apiNewBackBaseUrl + "Motivos/MotivosUpd", request);
  }

  DeleteMotivo(codigo: string): Observable<IAddMotivoResponse> {
    const request: IMotivoRequest = {
      que: 3,
      tope: "",
      cmd: "",
      codigo: codigo,
      tipo: "",
      descripcion: "",
      tipo_motivo: "",
      iIdioma: 0
    };
    return this.http.post<IAddMotivoResponse>(environment.apiNewBackBaseUrl + "Motivos/MotivosDelete", request);
  }

  GetCmsprOpciones(tabla: string, campo: string): Observable<IOpcionesResponse> {
    const request: IOpcionesRequest = {
      sTabla: tabla,
      sCampo: campo,
      iIdioma: 0
    };
    return this.http.post<IOpcionesResponse>(environment.apiNewBackBaseUrl + "OpcionesSolicitud/GetOpcionesVariables", request);
  }
}
